import React from 'react';
import { IconType } from 'react-icons';

// Interface for common icon props
export interface IconProps {
  className?: string;
  size?: number | string;
  color?: string;
  [key: string]: unknown;
}

// Utility function to safely render react-icons components
// This function handles the type compatibility issues between react-icons and React 17
export const renderIcon = (IconComponent: IconType, props: IconProps = {}) => {
  // Use React.createElement to avoid JSX type issues
  return React.createElement(
    IconComponent as React.ComponentType<IconProps>,
    props
  );
};

// Alternative approach using type assertion for better type safety
export const renderIconSafe = <T extends IconProps>(
  IconComponent: IconType,
  props: T
) => {
  return React.createElement(IconComponent as React.ComponentType<T>, props);
};
